<div class="flex flex-col gap-2">
	<div class="flex flex-row items-center">
		<span class="font-semibold text-lg flex-grow">Allegations</span>

		<div class="flex flex-row gap-2 portal-actions" *ngIf="complaintId > 0">
			<button type="button"
							*ngIf="!addingAllegation"
							mat-button
							color="primary"
							(click)="toggleAllegationForm(true)">
				Add
			</button>

			<button type="submit"
							*ngIf="addingAllegation"
							mat-button
							color="primary"
							[disabled]="allegationForm.invalid"
							form="allegationForm">
				Save
			</button>

			<button type="button"
							*ngIf="addingAllegation"
							mat-button
							color="warn"
							(click)="closeAllegation()">
				Cancel
			</button>

      <button type="button"
              mat-button
              color="primary"
              (click)="toggleArchived(!includeArchived)">
        {{ includeArchived ? 'Hide Archived' : 'Show Archived' }}
      </button>
		</div>
	</div>

	<mat-card *ngIf="complaintId === 0">
		<mat-card-content>
			Select a complaint to manage allegations.
		</mat-card-content>
	</mat-card>

	<div *ngIf="complaintId > 0 && !addingAllegation">
		<mat-table [dataSource]="allegationSource"
							 matSort
							 #allegationSort="matSort"
							 aria-describedby="allegations"
							 class="mat-elevation-z8">
			<ng-container matColumnDef="allegation">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Allegation </mat-header-cell>
				<mat-cell *matCellDef="let allegation" (click)="selectAllegation(allegation)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectAllegation(allegation))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectAllegation(allegation))">
					{{ allegation.allegation }}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="details">
				<mat-header-cell *matHeaderCellDef> Details </mat-header-cell>
				<mat-cell *matCellDef="let allegation" (click)="selectAllegation(allegation)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectAllegation(allegation))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectAllegation(allegation))">
					{{ allegation.details }}
				</mat-cell>
			</ng-container>

      <ng-container matColumnDef="archived">
				<mat-header-cell *matHeaderCellDef> Archived </mat-header-cell>
				<mat-cell *matCellDef="let allegation" (click)="selectAllegation(allegation)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectAllegation(allegation))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectAllegation(allegation))">
					{{ allegation.archived ? 'Yes' : 'No' }}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="actions">
				<mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
				<mat-cell *matCellDef="let allegation">
					<div class="flex flex-row gap-2 portal-actions">
						<button type="button"
										mat-icon-button
										color="primary"
										(click)="selectAllegation(allegation); $event.stopPropagation()"
										matTooltip="Edit Allegation"
										matTooltipShowDelay="500"
										aria-label="Edit Allegation">
							<mat-icon>edit</mat-icon>
						</button>

						<button type="button"
										mat-icon-button
										color="warn"
										(click)="archiveAllegation(allegation, !allegation.archived); $event.stopPropagation()"
										matTooltip="{{ allegation.archived ? 'Unarchive Allegation' : 'Archive Allegation' }}"
										matTooltipShowDelay="500"
										aria-label="Archive Allegation">
							<mat-icon>{{ allegation.archived ? 'unarchive' : 'archive' }}</mat-icon>
						</button>
					</div>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="allegationColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: allegationColumns;"></mat-row>
		</mat-table>

		<mat-paginator #allegationPaginator
									 [pageSize]="5"
									 [pageSizeOptions]="[5, 10, 25]"
									 showFirstLastButtons>
		</mat-paginator>
	</div>

	<form id="allegationForm"
				*ngIf="complaintId > 0 && addingAllegation"
				[formGroup]="allegationForm"
				class="flex flex-col gap-2"
				(ngSubmit)="saveAllegation()">
		<mat-card>
			<mat-card-content>
				<div class="flex flex-col gap-2">
					<mat-form-field class="w-full" appearance="fill">
						<mat-label>Allegation</mat-label>
						<mat-select formControlName="allegation">
							<mat-option *ngFor="let option of allegationOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<mat-form-field class="w-full" appearance="fill">
						<mat-label>Details</mat-label>
						<textarea matInput
											formControlName="details"
											rows="5"></textarea>
					</mat-form-field>
				</div>
			</mat-card-content>
		</mat-card>
	</form>
</div>
